export enum BoxesLabels {
  dimensions = "dimensions",
  type = "type",
  material = "material",
  print = "print",
}
